import { request } from "../utils/request.js"

export const dynamicKanban_getSaleVolume = (pojo, args) => request({
    url: 'dynamicKanban/getSaleVolume',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_getPendingOrderCount = (args) => request({
    url: 'dynamicKanban/getPendingOrderCount',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const dynamicKanban_getCommodityInOutQuantity = (args) => request({
    url: 'dynamicKanban/getCommodityInOutQuantity',
    method: 'GET',
    showFailMessage: true,
    ...args
})

// export const dynamicKanban_getFollowUpCount = (args) => request({
//     url: 'dynamicKanban/getFollowUpCount',
//     method: 'GET',
//     showFailMessage: true,
//     ...args
// })

export const dynamicKanban_getCommoditySpecQuantityWarningCount = (args) => request({
    url: 'dynamicKanban/getCommoditySpecQuantityWarningCount',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const dynamicKanban_getSaleData = (pojo, args) => request({
    url: 'dynamicKanban/getSaleData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_getCollectRank = (pojo, args) => request({
    url: 'dynamicKanban/getCollectRank',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_getSaleRank = (pojo, args) => request({
    url: 'dynamicKanban/getSaleRank',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_commodityPurchaseReport_getSumData = (pojo, args) => request({
    url: 'dynamicKanban/commodityPurchaseReport/getSumData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commodityPurchaseReport_getItemData = (pojo, args) => request({
    url: 'dynamicKanban/commodityPurchaseReport/getItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commodityPurchaseReport_exportItemData = (pojo, args) => request({
    url: 'dynamicKanban/commodityPurchaseReport/exportItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_supplierPurchaseReport_getSumData = (pojo, args) => request({
    url: 'dynamicKanban/supplierPurchaseReport/getSumData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_supplierPurchaseReport_getItemData = (pojo, args) => request({
    url: 'dynamicKanban/supplierPurchaseReport/getItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_commoditySaleReport_getSumData = (pojo, args) => request({
    url: 'dynamicKanban/commoditySaleReport/getSumData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commoditySaleReport_getItemData = (pojo, args) => request({
    url: 'dynamicKanban/commoditySaleReport/getItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commoditySaleReport_exportItemData = (pojo, args) => request({
    url: 'dynamicKanban/commoditySaleReport/exportItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_commodityCustomizeReport_getSumData = (pojo, args) => request({
    url: 'dynamicKanban/commodityCustomizeReport/getSumData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commodityCustomizeReport_getItemData = (pojo, args) => request({
    url: 'dynamicKanban/commodityCustomizeReport/getItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commodityCustomizeReport_export = (pojo, args) => request({
    url: 'dynamicKanban/commodityCustomizeReport/export',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_commodityCustomizePurchaseReport_getSumData = (pojo, args) => request({
    url: 'dynamicKanban/commodityCustomizePurchaseReport/getSumData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commodityCustomizePurchaseReport_getItemData = (pojo, args) => request({
    url: 'dynamicKanban/commodityCustomizePurchaseReport/getItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commodityCustomizePurchaseReport_export = (pojo, args) => request({
    url: 'dynamicKanban/commodityCustomizePurchaseReport/export',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_distributeFeeReport = (pojo, args) => request({
    url: 'dynamicKanban/distributeFeeReport',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dynamicKanban_commodityStockReport_getItemData = (pojo, args) => request({
    url: 'dynamicKanban/commodityStockReport/getItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})
export const dynamicKanban_commodityStockReport_exportItemData = (pojo, args) => request({
    url: 'dynamicKanban/commodityStockReport/exportItemData',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/dynamicKanban.js